import React from 'react';
import { PositionsList } from '@/clients/r2t/components/PositionsList';

const r2tChatConfig = {
    wsUrl: process.env.REACT_APP_CHATBOT_WS_URL || 'wss://chatbot-215277898238.us-central1.run.app/ws/chatbot',
    tagRegistry: {
        '#getOffersList': (result) => <PositionsList positions={result} />,
    },
};

export default r2tChatConfig;
